<template>
	<section>
		<div class="page__title page__title--with-buttons">
			<h1>Partage de fichiers</h1>
			<div class="button__container">
				<button class="button button--primary" @click="showClassSelector">Partager des fichiers</button>
			</div>
		</div>
		<p class="page__description">Vous trouverez dans cet espace des ressources partagées par la communauté d'enseignants. Vous pouvez également partager vos propres ressources.</p>
		<a class="page__open-info" @click="isPopUpFlashVisible = !isPopUpFlashVisible"></a>
		
		<SharedFilesTable 
			:sharedFiles="sharedFiles" 
			:totalCount="totalCount"
			:currentPage="currentPage"
			:totalPages="totalPages"
			:loading="loading"
			@page-changed="handlePageChange"
			@filters-changed="handleFiltersChange"
		/>

		<!-- Popup de sélection de classe -->
		<Teleport to="body">
			<PopUpSelectClass 
				v-if="isClassSelectorVisible" 
				@close="isClassSelectorVisible = false"
			/>
		</Teleport>
	</section>
</template>

<script>
import { allSharedFilesService } from '../../../../../services/filesService'
import SharedFilesTable from './SharedFilesTable.vue'
import PopUpSelectClass from '../../../../PopUp/PopUpSelectClass.vue'

export default {
	components: {
		SharedFilesTable,
		PopUpSelectClass
	},

	methods: {
		showClassSelector() {
			// S'assurer que les classes sont chargées avant d'afficher la popup
			if (!this.$store.state.classes || this.$store.state.classes.length === 0) {
				this.$store.dispatch('getClasses').then(() => {
					this.isClassSelectorVisible = true
				})
			} else {
				this.isClassSelectorVisible = true
			}
		},
		async loadSharedFiles(page = 1, filters = null) {
			try {
				this.loading = true
				const filtersToUse = filters || this.currentFilters
				
				// Séparer les filtres backend des filtres frontend
				const backendFilters = { ...filtersToUse }
				const searchKeyword = backendFilters.search
				delete backendFilters.search // Retirer search pour l'API backend
				
				let allFiles = []
				let totalServerCount = 0
				
				// Si on a une recherche et qu'on a déjà des résultats en cache avec les mêmes filtres backend
				const cacheKey = JSON.stringify(backendFilters)
				if (searchKeyword && searchKeyword.trim() && this.cachedSearchResults && this.cachedSearchResults.cacheKey === cacheKey) {
					allFiles = this.cachedSearchResults.files
					totalServerCount = this.cachedSearchResults.totalCount
				} else {
					// Si on a une recherche, on récupère plus de résultats pour filtrer côté client
					const pageSize = searchKeyword && searchKeyword.trim() ? 100 : this.itemsPerPage
					const currentPage = searchKeyword && searchKeyword.trim() ? 1 : page
					
					const response = await allSharedFilesService(currentPage, pageSize, backendFilters)
					
					if (response && response.results) {
						allFiles = response.results
						totalServerCount = response.count
						
						// Mettre en cache les résultats si c'est une recherche
						if (searchKeyword && searchKeyword.trim()) {
							this.cachedSearchResults = {
								cacheKey,
								files: allFiles,
								totalCount: totalServerCount
							}
						}
					} else {
						allFiles = Array.isArray(response) ? response : []
						totalServerCount = allFiles.length
					}
				}
				
				let files = allFiles
				
				// Filtrage côté frontend pour la recherche par mot-clé
				if (searchKeyword && searchKeyword.trim()) {
					const keyword = searchKeyword.toLowerCase().trim()
					const filteredFiles = allFiles.filter(file => 
						file.name.toLowerCase().includes(keyword)
					)
					
					// Pagination côté client pour les résultats filtrés
					const startIndex = (page - 1) * this.itemsPerPage
					const endIndex = startIndex + this.itemsPerPage
					files = filteredFiles.slice(startIndex, endIndex)
					
					this.totalCount = filteredFiles.length
					this.totalPages = Math.ceil(filteredFiles.length / this.itemsPerPage)
				} else {
					this.totalCount = totalServerCount
					this.totalPages = Math.ceil(totalServerCount / this.itemsPerPage)
				}
				
				this.sharedFiles = files
				
			} catch (error) {
				console.error("Erreur lors du chargement des fichiers partagés:", error)
				this.sharedFiles = []
				this.totalCount = 0
				this.totalPages = 0
			} finally {
				this.loading = false
			}
		},
		handlePageChange(page) {
			this.currentPage = page
			// Si on a une recherche active, on ne peut pas utiliser la pagination côté serveur
			if (this.currentFilters.search && this.currentFilters.search.trim()) {
				// Pour une recherche, on doit recharger toutes les données et filtrer côté client
				this.loadSharedFiles(1, this.currentFilters)
			} else {
				this.loadSharedFiles(page + 1)
			}
		},
		handleFiltersChange(filters) {
			this.currentFilters = filters
			this.currentPage = 0
			this.initialLoadDone = true
			// Réinitialiser la cache des résultats quand les filtres changent
			this.cachedSearchResults = null
			this.loadSharedFiles(1, filters)
		}
	},
	data() {
		return {
			sharedFiles: [],
			totalCount: 0,
			currentPage: 0,
			totalPages: 0,
			loading: false,
			itemsPerPage: 10,
			currentFilters: {},
			initialLoadDone: false,
			cachedSearchResults: null,
			isClassSelectorVisible: false
		}
	},
	async created() {
		// Charger les classes de l'utilisateur pour le bouton de partage
		if (!this.$store.state.classes || this.$store.state.classes.length === 0) {
			await this.$store.dispatch('getClasses')
		}
		
		setTimeout(() => {
			if (!this.initialLoadDone) {
				this.initialLoadDone = true
				this.loadSharedFiles(1)
			}
		}, 100)
	}
}
</script>